export default "__VITE_ASSET__DSmnm2O6__"